import merge from 'deepmerge';
import { IntlProvider as ReactIntlProvider, addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import zh from 'react-intl/locale-data/zh';
import de from 'react-intl/locale-data/de';
import { connect } from 'react-redux';
import engine from 'store/src/store-engine';
import sessionStorages from 'store/storages/sessionStorage';
import plugins from 'store/plugins/expire';
import { translation, DEFAULT_LANGUAGE } from '../config';

addLocaleData([...en, ...zh, ...de]);

export function updateLanguage(dispatch, key) {
  dispatch({
    type: 'INTL_UPDATE',
    payload: {
      locale: key,
      messages: translation[key],
    },
  });
  const sessionStore = engine.createStore(sessionStorages, plugins);
  sessionStore.set('lang', key);
  console.log('updateLanguage - key = ', key);
}

const initialState = {
  locale: DEFAULT_LANGUAGE,
  messages: translation[DEFAULT_LANGUAGE],
};

export const intlReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'INTL_UPDATE':
      return merge({}, action.payload);
    default:
      return state;
  }
};

const mapStateToProps = state => ({
  locale: state.get('intl').locale,
  messages: state.get('intl').messages,
});

export const IntlProvider = connect(mapStateToProps)(ReactIntlProvider);
